import React from 'react';
import { DockerImageDto } from 'dto/raptor-docker-image.dto';
import { TableUtils } from 'pages/private/components/table-utils';
import { IBasicTableColumn } from 'ui-lib';
import { IRecordPickerFormItemProps, RecordPickerFormItem } from 'pages/private/components/record-picker';

const DOCKER_IMAGE_COLUMNS: IBasicTableColumn[] = [
    TableUtils.createBasicFilterColumn<DockerImageDto>({ title: 'Image Name', key: 'name' }),
    TableUtils.createBasicFilterColumn<DockerImageDto>({ title: 'Tag', key: 'tag' }),
    TableUtils.createBasicFilterColumn<DockerImageDto>({ title: 'Size (MB)', key: 'sizeInMB' }),
    TableUtils.createBasicFilterTimeColumn<DockerImageDto>({ title: 'Updated At', key: 'updatedAt' }),
];

export type IDockerImagesPickerFormItemProps = Omit<IRecordPickerFormItemProps<DockerImageDto>, 'columns' | 'renderRecordTag'>;

export const DockerImagesPickerFormItem = (props: IDockerImagesPickerFormItemProps): JSX.Element => {
    return (
        <RecordPickerFormItem<DockerImageDto>
            {...props}
            renderRecordTag={(dockerImage) => dockerImage.displayName}
            columns={DOCKER_IMAGE_COLUMNS}
        />
    );
};
